import { useMediaQuery } from "@vueuse/core"
import { computed } from "vue"

/**
 *  Breakpoint follow ant-design-vue
 *  {@see https://2x.antdv.com/components/layout/#Responsive}
 */
const xs = useMediaQuery("(min-width: 0) and (max-width:575px)")
const sm = useMediaQuery("(min-width: 576px) and (max-width:767px)")
const md = useMediaQuery("(min-width: 768px) and (max-width:991px)")
const lg = useMediaQuery("(min-width: 992px) and (max-width:1199px)")
const xl = useMediaQuery("(min-width: 1200px) and (max-width:1599px)")
const xxl = useMediaQuery("(min-width: 1600px)")

export const breakpoint = computed(() => ({
  xs: xs.value,
  sm: sm.value,
  md: md.value,
  lg: lg.value,
  xl: xl.value,
  xxl: xxl.value,
}))

/**
 * 取得媒體簡介
 * ex: https://youtube.com/oembed?format=json&url=https%3A%2F%2Fyoutu.be%2FJn09UdSb3aA%3Fsi%3DD5fUpyPnXbSSohPD
 * @param {*} url 
 * @returns string || null
 */
//  
export const oembedUrl = (url) => {
  const domain = (new URL(url))

  const youtube = ['www.youtube.com', 'youtube.com', 'youtu.be']
  const vimeo = ['www.vimeo.com', 'vimeo.com']
  const facebook = ['www.facebook.com', 'facebook.com', 'fb.watch']
  if (youtube.includes(domain.hostname)) {
    return 'https://youtube.com/oembed?format=json&url=' + encodeURIComponent(url)
  } else if (vimeo.includes(domain.hostname)) {
    return 'https://vimeo.com/api/oembed.json?url=' + encodeURIComponent(url)
  } else if (facebook.includes(domain.hostname)) {
    console.log("不支援播放: ", domain.hostname)
  } else {
    console.log("others: ", domain.hostname)
  }

  return null
}

export const parseVideoUrl = (url) => {
  let domain = (new URL(url))
  // console.log("domain: ", domain.hostname)
  // console.log("parseVideoUrl: ", url)
  if (url.indexOf('youtu.be') > -1) {
    return url.replace('youtu.be', 'youtube.com/embed')
  } else if (url.indexOf('youtube.com') > -1) {
    return url.replace('watch?v=', 'embed/')
  } else if (url.indexOf('//vimeo.com') > -1) {
    return url.replace('//vimeo.com', '//player.vimeo.com/video')
  } else if (url.indexOf('fb.watch/') > -1 || url.indexOf('facebook.com/facebook/videos/') > -1) {
    return `https://www.facebook.com/plugins/video.php?href=${encodeURIComponent(url)}&show_text=false&t=0`
  } else {
    console.log("others: ", domain)
  }

  return url
}
export const parseVideoTag = (htmlString,  width="560", height="315") => {
  let parser = new DOMParser()
  const doc = parser.parseFromString(htmlString, "text/html")
  let embeds = doc.body.getElementsByTagName("oembed")
  // console.log("embeds: ", embeds)
  if (embeds.length) {
      embeds.forEach((el) => {
          var uri = el.getAttribute("url")
          var parsedUrl = parseVideoUrl(uri)

          el.outerHTML = el.outerHTML
              .replace('url', 'src')
              .replace(uri, parsedUrl)

      })
      // console.log("embeds2: ", embeds)
  }
  doc.body.innerHTML = doc.body.innerHTML.replace(/<oembed/g, '<oembed width="'+width+'" height="'+height+'"')
  doc.body.innerHTML = doc.body.innerHTML.replace(/oembed/g, 'iframe')
  // console.log("innerHTML: ", doc.body.innerHTML)
  return doc.body.innerHTML
}